const Fetcher = require('./fetcher');
const {trackComponentDisplayedEvent} = require('od-modules/track_events/track.frontevents.utils');

const ANCILLARIES_SERVICES = {BAGS: 'BAGS', SEATS: 'SEATS'};

class PbAncillariesCollection {
    constructor() {
        this.tripBagsFetcher = new Fetcher({service: ANCILLARIES_SERVICES.BAGS, action: 'getBags'});
        this.tripSeatsFetcher = new Fetcher({service: ANCILLARIES_SERVICES.SEATS, action: 'getSeats'});
        this.checkInSeatsFetcher = new Fetcher({service: ANCILLARIES_SERVICES.SEATS, action: 'getSeatsCheckIn'});
    }

    loadTripBags(bookingDetailDTO = {}) {
        return this.tripBagsFetcher.load(bookingDetailDTO);
    }

    onTripBagsLoaded(data = {}) {
        this.tripBagsFetcher.subscribe(data);
    }

    loadTripSeats(bookingDetailDTO = {}) {
        return this.tripSeatsFetcher.load(bookingDetailDTO);
    }

    onTripSeatsLoaded(data = {}) {
        this.tripSeatsFetcher.subscribe(data);
    }

    loadCheckInSeats(bookingDetailDTO = {}) {
        const timeout = Odigeo.AB.isCheckinDamageControlEnabledB ? 4000 : 6000;
        const timeoutCallback = () => {
            trackComponentDisplayedEvent('checkin-funnel-timeout')
                .then(this.redirectToCheckinForm)
                .catch(this.redirectToCheckinForm);
        };
        const options = Odigeo.Device.navigator.isNative() && Odigeo.AB.isCheckinDamageControlEnabled ? {timeout, timeoutCallback} : {};

        return this.checkInSeatsFetcher.load(bookingDetailDTO, options);
    }

    onCheckInSeatsLoaded(data = {}) {
        this.checkInSeatsFetcher.subscribe(data);
    }

    redirectToCheckinForm() {
        window.location.href = window.location.href.replace('#checkin-funnel', '#checkin-form');
        window.location.reload();
    }
}

module.exports = new PbAncillariesCollection();
